<template>
  <Modal title="重置密码" v-model="visible" width="415" class="my-modal top" :mask-closable="false" :footer-hide="true">
    <Form ref="form" :model="formData" class="page-form" :label-width="75">
      <FormItem prop="newPassword" label="新密码" class="full" :rules="$units.formRule.required('请输入')">
        <Input :type="pwdShow1?'text':'password'" v-model="formData.newPassword" placeholder="请输入您的密码"/>
        <Icon type="ios-eye" class="password-icon" v-if="pwdShow1" @click="pwdShow1=false"/>
        <img src="@static/images/login/eye.png" class="password-icon" v-else @click="pwdShow1=true"/>
      </FormItem>
      <FormItem prop="rePassword" label="确认密码" :rules="$units.formRule.required('请输入')" class="full">
        <Input :type="pwdShow2?'text':'password'" v-model="formData.rePassword" placeholder="请再次输入您的密码"/>
        <Icon type="ios-eye" class="password-icon" v-if="pwdShow2" @click="pwdShow2=false"/>
        <img src="@static/images/login/eye.png" class="password-icon" v-else @click="pwdShow2=true"/>
        <div class="info-text">注:密码8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种，且不能包含账号</div>
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible=false">取消</Button>
      <Button type="primary" @click="save" :loading="loading">确认</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      visible:false,
      loading:false,
      pwdShow1: false,
      pwdShow2: false,
      formData:{
        newPassword:"",
        rePassword:"",
      },
    };
  },
  watch: {},
  computed: {
  },
  created() {},
  mounted() {
  },
  methods: {
    save(){
      this.$refs.form.validate().then(isok=>{
        if(!isok){
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        if(!this.verification(formData.newPassword)){
          return;
        }
        if(formData.newPassword!=formData.rePassword){
          this.$notice.error("2次输入密码不一致，请检查");
          return;
        }
        const now = this.$units.formatDate(new Date(), 'yyyyMMdd');
        formData.newPassword = this.$units.sm4Encrypt(formData.newPassword, now + now);
        formData.rePassword = this.$units.sm4Encrypt(formData.rePassword, now + now);
        this.$http({
          url: "/buz/userBase/modifyPassword",
          type: "POST",
          data: formData,
        }).then(res=>{
          this.visible = false;
          this.$notice.success("密码已重置成功")
        })
        
      })
    },
    open(data){
      this.visible = true;
      this.$refs.form&&this.$refs.form.resetFields();
      this.formData.id = data.id
    },
    verification(password) {
      const capital = /[A-Z]/;
      const regLetter = /[a-z]/;
      const regNum = /[0-9]/;
      const regTeShu = new RegExp(
        "[`_~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？+-]"
      );

      let complex = 0;
      if (capital.test(password)) {
        ++complex;
      }
      if (regLetter.test(password)) {
        ++complex;
      }
      if (regNum.test(password)) {
        ++complex;
      }
      if (regTeShu.test(password)) {
        ++complex;
      }
      if (complex < 3 || password.length < 8 || password.length > 16) {
        this.$notice.error(
          "密码8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种，且不能包含账号"
        ); //iview中的一个提示框
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.my-modal {
  .info-text {
    font-size: 12px;
    color: #A8ADB7;
    line-height: 1.5;
    padding-top: 7px;
  }
  .password-icon {
    position: absolute;
    transform: translateX(-30px);
  }
  img.password-icon {
    width: 16px;
    top: 8px;
  }
  .ivu-icon-ios-eye {
    font-size: 18px;
    color: #A8ADB7;
    top: 7px;
  }
}
</style>